import { FormItemResponseDTO } from '@/api/base/DTOs';
import { adaptFormItemResponseToFormFields } from '.';
import { FormField, IFormBase } from '@/forms/typings';

export const adaptFormItemArrayResponseToFormFields = (
  sectionItemResponse: FormItemResponseDTO[],
  parentFieldId?: IFormBase['fieldId'],
): FormField[] =>
  sectionItemResponse.map(child =>
    adaptFormItemResponseToFormFields(child, parentFieldId),
  );
